import React, { useState, useEffect, useRef } from "react";
import { updateDoc, doc, getDoc } from "firebase/firestore";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { db, auth } from "../FirebaseConfig";
import { UserAuth } from "../Context";
import {
  EmailAuthProvider,
  updatePassword,
  reauthenticateWithCredential,
} from "firebase/auth";
import { toastOptions } from "../lib/toastOptions";
import useUserCountry from "../StatesStore/UserCountry";
// import { Link } from 'react-router-dom';
import { StandaloneSearchBox, useJsApiLoader } from "@react-google-maps/api";
import { Link } from "react-router-dom";
const AccountSetting = () => {
  const { user } = UserAuth();
  const [showPassword, setShowPassword] = useState(false);
  const [userData, setUserData] = useState({
    firstName: "",
    lastName: "",
    userName: "",
    birthday: "",
    gender: "",
    phoneNumber: "",
    email: "",
    overview: "",
    location: "",
    userTitle: "",
    region: "",
    requestList: [],
    sendList: [],
    friendList: [],
  });
  const libraries = ["places"];
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const isGoogleUser =
    user &&
    user.providerData &&
    user.providerData.some((provider) => provider.providerId === "google.com");
  const [passwordMismatchError, setPasswordMismatchError] = useState("");

  const [firstNameError, setFirstNameError] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const country = useUserCountry((state) => state.country);
  const inputRef = useRef();

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyDeRZ4H3Pg1YWsVb-ZX1GDqNN7hp7PaRw8",
    libraries,
  });

  const handlePlaceChanged = () => {
    const [place] = inputRef.current.getPlaces();
    if (place) {
      console.log(place.formatted_address);
      console.log(place.geometry.location.lat());
      console.log(place.geometry.location.lng());
      setUserData({ ...userData, location: place.formatted_address });
    }
  };

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        if (user && user.uid) {
          const userDocRef = doc(db, "users", user.uid);
          const userDocSnapshot = await getDoc(userDocRef);

          if (userDocSnapshot.exists()) {
            const userDataFromDb = userDocSnapshot.data();
            console.log(userDataFromDb.birthday);
            setUserData({
              firstName: userDataFromDb.firstName || "",
              lastName: userDataFromDb.lastName || "",
              userName: userDataFromDb.userName || "",
              birthday: userDataFromDb.birthday || "",
              gender: userDataFromDb.gender || "",
              phoneNumber: userDataFromDb.phoneNumber || "",
              email: userDataFromDb.email || "",
              overview: userDataFromDb.overview || "",
              userTitle: userDataFromDb.userTitle || "",
              location: userDataFromDb.location || "",
              region: userDataFromDb.region || "",
              requestList: userDataFromDb.requestList || [],
              sendList: userDataFromDb.sendList || [],
              friendList: userDataFromDb.friendList || [],
            });
          }
        }
      } catch (error) {
        console.error("Error fetching user data from database", error);
      }
    };

    fetchUserData();
  }, [user, country]);

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    const nameRegex = /^[a-zA-Z\s]*$/;
    if (!nameRegex.test(userData.firstName)) {
      setFirstNameError("First name should only contain letters.");
      return;
    } else {
      setFirstNameError("");
    }

    if (!nameRegex.test(userData.lastName)) {
      setLastNameError("Last name should only contain letters.");
      return;
    } else {
      setLastNameError("");
    }
    try {
      const userDocRef = doc(db, "users", user.uid);
      const mergedUserName = `${userData.firstName} ${userData.lastName}`;
      await updateDoc(userDocRef, {
        firstName: userData.firstName
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        lastName: userData.lastName
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        userName: mergedUserName,
        birthday: userData.birthday,
        gender: userData.gender,
        phoneNumber: userData.phoneNumber,
        email: userData.email,
        overview: userData.overview,
        userTitle: userData.userTitle,
        location: userData.location,
        requestList: userData.requestList,
        sendList: userData.sendList,
        friendList: userData.friendList,
      });
      console.log("User profile updated successfully");
      toast.success("Profile updated successfully", toastOptions);
    } catch (error) {
      console.error("Error updating user profile", error);
      toast.error("Error updating user profile", toastOptions);
    }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    try {
      if (auth && user && user.email) {
        if (newPassword === confirmPassword) {
          const credential = EmailAuthProvider.credential(
            user.email,
            currentPassword
          );
          await reauthenticateWithCredential(auth.currentUser, credential);
          await updatePassword(auth.currentUser, newPassword);
          console.log("Password updated successfully");
          toast.success("Password updated successfully", toastOptions);
          setPasswordMismatchError("");
          setCurrentPassword("");
          setNewPassword("");
          setConfirmPassword("");
        } else {
          console.error("New password and confirm password do not match");
          setPasswordMismatchError(
            "New password and confirm password do not match"
          );
        }
      } else {
        console.error("Auth object or user information is not available");
      }
    } catch (error) {
      console.error("Error updating password", error);
      if (error.code === "auth/wrong-password") {
        setPasswordMismatchError("Current password is incorrect");
      } else {
        setPasswordMismatchError("Error updating password. Please try again.");
      }
    }
  };
  return (
    <>
      <div className="py-0 py-md-3">
        {/* Tab Navigation */}
        <style jsx>
          {`
            .labelClass {
              font-family: Inter;
              font-weight: 400;
              font-style: Regular;
              font-size: 16px;
              line-height: 100%;
              letter-spacing: 0%;
              margin-bottom: 6px;
            }

            .inputClass {
              border-radius: 12px;
              border-width: 1px;
              padding: 10px;
            }
          `}
        </style>

        <form className="row g-3 mx-0" onSubmit={(e) => handleFormSubmit(e)}>
          <div className="col-sm-6 px-0 pe-lg-3">
            <label
              for="firstName"
              className="labelClass"
              style={{ color: "black" }}
            >
              First Name
            </label>
            <input
              type="text"
              id="firstName"
              className="form-control inputClass"
              value={userData.firstName}
              onChange={(e) => {
                setUserData({ ...userData, firstName: e.target.value });
                setFirstNameError("");
              }}
            />
            {firstNameError && (
              <span style={{ color: "red" }}>{firstNameError}</span>
            )}
          </div>
          <div className="col-sm-6 px-0 ps-lg-3">
            <label
              for="lastName"
              className="labelClass"
              style={{ color: "black" }}
            >
              Last Name
            </label>
            <input
              id="lastName"
              type="text"
              className="form-control inputClass"
              value={userData.lastName}
              onChange={(e) => {
                setUserData({ ...userData, lastName: e.target.value });
                setLastNameError("");
              }}
            />
            {lastNameError && (
              <span style={{ color: "red" }}>{lastNameError}</span>
            )}
          </div>
          <div className="col-sm-6 px-0 pe-lg-3">
            <label
              for="nickName"
              className="labelClass"
              style={{ color: "black" }}
            >
              Nickname/Title
            </label>
            <input
              id="nickName"
              type="text"
              className="form-control inputClass"
              value={userData.userTitle}
              onChange={(e) =>
                setUserData({ ...userData, userTitle: e.target.value })
              }
            />
          </div>
          <div className="col-sm-6 px-0 ps-lg-3">
            <label
              for="birthday"
              className="labelClass"
              style={{ color: "black" }}
            >
              Birthday{" "}
            </label>
            <div
              style={{ backgroundColor: "#eff2f6" }}
              className="input-group form-control inputClass"
            >
              {userData.birthday}
            </div>
          </div>
          <div className="col-sm-6 px-0 pe-lg-3">
            <label
              for="email"
              className="labelClass"
              style={{ color: "black" }}
            >
              Email
            </label>
            <div className="input-group form-control inputClass">
              {userData.email}
            </div>
          </div>
          <div className="col-sm-6 px-0 ps-lg-3">
            <label
              for="phoneNumber"
              className="labelClass"
              style={{ color: "black" }}
            >
              Phone number
            </label>
            <input
              id="phoneNumber"
              type="text"
              className="form-control inputClass"
              value={userData.phoneNumber}
              onChange={(e) =>
                setUserData({ ...userData, phoneNumber: e.target.value })
              }
            />
          </div>
          <div className="col-sm-6 px-0 pe-lg-3">
            <label
              for="location"
              className="labelClass"
              style={{ color: "black" }}
            >
              Location
            </label>
            {isLoaded && (
              <StandaloneSearchBox
                onLoad={(ref) => (inputRef.current = ref)}
                onPlacesChanged={handlePlaceChanged}
              >
                <input
                  id="location"
                  type="text"
                  className="form-control inputClass flatpickr"
                  value={userData.location}
                  onChange={(e) =>
                    setUserData({ ...userData, location: e.target.value })
                  }
                  placeholder="Enter Location"
                />
              </StandaloneSearchBox>
            )}
          </div>
          <div className="col-12 px-0">
            <label
              for="overview"
              className="labelClass"
              style={{ color: "black" }}
            >
              Overview
            </label>
            <textarea
              id="overview"
              className="form-control inputClass"
              rows="3"
              value={userData.overview}
              onChange={(e) =>
                setUserData({ ...userData, overview: e.target.value })
              }
            ></textarea>
            <small>Character limit: 300</small>
          </div>
          <div className="d-md-none col-12 px-0">
            <button type="submit" className="btn btn-primary mb-0 w-100">
              Save changes
            </button>
          </div>
          <div className="d-none d-md-block col-12 text-end px-0">
            <button type="submit" className="btn btn-primary mb-0">
              Save changes
            </button>
          </div>
        </form>
      </div>
      {!isGoogleUser && (
        <div>
          <div className="card-header border-0 pb-0">
            <h5 className="card-title text-black pb-3">Change your password</h5>
          </div>
          <div className="card-body">
            <form className="row g-3" onSubmit={(e) => handleChangePassword(e)}>
              <div className="col-12">
                <label className="labelClass" style={{ color: "black" }}>
                  Current password
                </label>
                <input
                  type="password"
                  className="form-control inputClass"
                  placeholder="Enter current password"
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                />
              </div>
              {passwordMismatchError && (
                <div className="text-danger mt-2">{passwordMismatchError}</div>
              )}
              <div className="col-12">
                <label className="labelClass" style={{ color: "black" }}>
                  New password
                </label>
                <div className="input-group">
                  <input
                    className="form-control inputClass"
                    type={showPassword ? "text" : "password"}
                    placeholder="Enter new password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                  <span
                    onClick={() => setShowPassword(!showPassword)}
                    className="input-group-text p-0"
                  >
                    <i
                      className={`fakepasswordicon fa-solid fa-eye${
                        showPassword ? "" : "-slash"
                      } cursor-pointer p-2 w-40px`}
                    ></i>
                  </span>
                </div>
              </div>
              <div className="col-12">
                <label className="labelClass" style={{ color: "black" }}>
                  Confirm password
                </label>
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control inputClass"
                  placeholder="Confirm new password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </div>
              <div className="col-12 text-end">
                <button type="submit" className="btn btn-primary mb-0">
                  Update password
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default AccountSetting;
